import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Conditional } from 'iq-blueberry'

import './style.styl'

const Modal = ({
  children,
  backdrop = true,
  onCloseModal,
  clickableBackdrop = true,
  openedModals = {},
  modalName,
  className,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (openedModals?.[modalName]?.isOpen) {
      setIsModalOpen(true)
    } else {
      setIsModalOpen(false)
    }
    
  }, [openedModals])

  function handleBackdropClick() {
    if (clickableBackdrop) {
      onCloseModal()
    }
  }

  return isModalOpen ? (
    <div className={`app-modal ${className}`}>
      <Conditional
        condition={!!backdrop}
        renderIf={
          <div onClick={handleBackdropClick} className="app-modal__backdrop" />
        }
      />
      <div className="app-modal__content">{children}</div>
    </div>
  ) : null
}

Modal.propTypes = {
  backdrop: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  clickableBackdrop: PropTypes.bool,
  modalName: PropTypes.string.isRequired,
  openedModals: PropTypes.object.isRequired,
}

export default Modal
